// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__w4shZ","more":"styles_more__3PVqM"};